document.querySelectorAll('#custom-slider').forEach(s => {
  const next = s.querySelector('.btn.next');
  const prev = s.querySelector('.btn.prev');
  const slides = s.querySelectorAll('.slide');
  const track = s.querySelector('.slides-track') || s;

  if (!next || !prev || !slides.length) return;

  const isRTL = document.documentElement.dir === 'rtl';
  const slideWidth = slides[0].offsetWidth + 24;

  function move(dir) {
    const scrollAmount = dir === 'next' ? slideWidth : -slideWidth;

    if (isRTL) {
      track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    } else {
      track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  }

  next.onclick = () => move('next');
  prev.onclick = () => move('prev');
});